import { Accordion as AAccordion } from '@ark-ui/solid/accordion';
import { IconChevronDown } from '@bbr/icons/chevron-down-outline';
import type { ComponentProps } from 'solid-js';

export function Accordion(props: ComponentProps<typeof AAccordion.Root>) {
	return <AAccordion.Root multiple {...props} class="flex flex-col gap-2 text-start lg:gap-4" />;
}

Accordion.Item = function AccordionItem(props: ComponentProps<typeof AAccordion.Item>) {
	return (
		<AAccordion.Item
			{...props}
			class="rounded-md border border-zinc-200 bg-zinc-100 dark:border-zinc-800 dark:bg-zinc-900"
		/>
	);
};

Accordion.Header = function AccordionHeader(props: ComponentProps<typeof AAccordion.ItemTrigger>) {
	return (
		<AAccordion.ItemTrigger
			{...props}
			class="flex w-full cursor-pointer items-center justify-between rounded-md px-2 py-3 text-start font-semibold outline-none focus-visible:ring-4 focus-visible:ring-yellow-500/50 lg:px-6 lg:py-4 data-[state=open]:[&_svg]:rotate-180"
		>
			{props.children}
			<AAccordion.ItemIndicator>
				<IconChevronDown class="transition-transform" />
			</AAccordion.ItemIndicator>
		</AAccordion.ItemTrigger>
	);
};

Accordion.Content = function AccordionContent(props: ComponentProps<typeof AAccordion.ItemContent>) {
	return (
		<AAccordion.ItemContent
			{...props}
			class="overflow-hidden px-2 pt-0 pb-3 text-sm animation-duration-100 data-[state=closed]:animate-aaccordion-up data-[state=open]:animate-aaccordion-down lg:px-6 lg:pb-4"
		/>
	);
};
